// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { addOnlineCourseToCart } from '../../apis/ec';
import { addOnlineCourseToCartActions } from '../actionCreators/addOnlineCourseToCartActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: addOnlineCourseToCartActions.success,
  failure: addOnlineCourseToCartActions.failure
};

type RequestActionTypes = ActionType<
  typeof addOnlineCourseToCartActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const addOnlineCourseToCartEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(addOnlineCourseToCartActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, callback } = action.payload;
      // send api promise
      return addOnlineCourseToCart(id)
        .then((response: any) => {
          // handle success case here
          return addOnlineCourseToCartActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return addOnlineCourseToCartActions.failure({ error });
        })
        .finally(() => callback())
    })
  );
};
